//#region importsSecion

import React, { useState } from "react";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import swal from "sweetalert";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import { ApiFinance } from "../funds/ApiFinance";
import {
  applyClassToCharacters,
  getStringFromJSX,
  LoadingSpinner,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetSelectedLanguage } from "../helper/Method";

//#endregion importsSecion
const ACTION_TYPES = {
  APPROVE: 1,
  REJECT: 2,
  HOLD: 3,
};
const TransactionActionModal = ({
  setViewTransactionActionModal,
  notificationId,
  isNotificationForwarded,
  notificationName,
  setRefreshList,
}) => {
  //#region stateSection
  const [errors, setErrors] = useState({});

  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const memberId = parseInt(encryptStorage.getItem("memberId"));
  const responsibilityId = parseInt(encryptStorage.getItem("responsibilityId"));

  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const toggle = () => setViewTransactionActionModal(false);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const [state, setState] = useState({
    defaulValue: true,

    notificationAction: {
      code: ACTION_TYPES.APPROVE,
      notificationId,
      createdById: memberId,
      responsibilityId,
      comments: "",
      refrenceNo: "",
      loggedInUnitId,
      feedback: "",
    },

    extraFile: null,
  });

  //#endregion stateSection

  //#region useEffectSection

  //#endregion useEffectSection

  //#region validationSection
  const validate = () => {
    let temp = {};

    const isMarkaz = unitTypeName === "Markaz";

    if (isMarkaz) {
      if (!state.notificationAction.refrenceNo?.trim()) {
        temp.refrenceNo = "Reference number is required";
      }

      if (!state.extraFile) {
        temp.extraFile = "Deposit slip file is required";
      }
    }

    setErrors(temp);

    return Object.keys(temp).length === 0;
  };
  //#endregion validationSection

  //#region handlers

  const handleApprovalStatus = (code) => {
    setState((prev) => ({
      ...prev,
      defaulValue: code === ACTION_TYPES.APPROVE,
      notificationAction: {
        ...prev.notificationAction,
        code,
      },
    }));

    setErrors({}); // reset errors on code change
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      notificationAction: {
        ...prev.notificationAction,
        [name]: value,
      },
    }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  //#endregion handlers

  //#region submitHandler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      const formData = new FormData();

      // append notificationAction fields
      Object.entries(state.notificationAction).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      // append file only if exists
      if (state.extraFile) {
        formData.append("File", state.extraFile);
      }
      const res = await ApiFinance().TransferNotificationAction(formData);

      if (res.data.statusCode === "200") {
        swal({
          title: t(res.data.message),
          icon: "success",
          buttons: "OK",
        });
        setRefreshList((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
      swal({
        title: t(err.response?.data) || err,
        icon: "error",
        buttons: "OK",
        className: GetSelectedLanguage() === "en" ? "en" : "ur",
      });
    } finally {
      setLoading(false);
      setViewTransactionActionModal(false);
    }
  };
  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal size="xl" isOpen={true} className="inmodal">
        <ModalHeader className="modal-title" tag="h4">
          Action
        </ModalHeader>
        {loading ? (
          <ModalBody>
            <div className="text-center" style={{ width: "100%" }}>
              <LoadingSpinner />
            </div>
          </ModalBody>
        ) : (
          <>
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                <div className="ibox-content">
                  {/* Action Radio Buttons */}
                  <FormGroup>
                    <Label className="m-0">
                      <h4>{<GetLanguageString props="common_action" />}</h4>
                    </Label>
                    <Row>
                      <Col md="4" className="text-center">
                        <Label className="col-form-label">
                          <Input
                            type="radio"
                            name="code"
                            className="m-1"
                            value={ACTION_TYPES.APPROVE}
                            checked={state.defaulValue}
                            onChange={() =>
                              handleApprovalStatus(ACTION_TYPES.APPROVE)
                            }
                          />{" "}
                          {unitTypeName === "Markaz" ? (
                            <GetLanguageString props="notifications_action_approve" />
                          ) : unitTypeName === "Halqa" ? (
                            <GetLanguageString props="notifications_forward_request" />
                          ) : (
                            <GetLanguageString props="notifications_forward_request" />
                          )}
                        </Label>
                      </Col>

                      <Col md="4" className="text-center">
                        <Label className="col-form-label">
                          <Input
                            type="radio"
                            name="code"
                            className="m-1"
                            value={ACTION_TYPES.REJECT}
                            onChange={() =>
                              handleApprovalStatus(ACTION_TYPES.REJECT)
                            }
                          />{" "}
                          {
                            <GetLanguageString props="notifications_action_reject" />
                          }
                        </Label>
                      </Col>
                      <Col md="4" className="text-center">
                        <Label className="col-form-label">
                          <Input
                            type="radio"
                            name="code"
                            className="m-1"
                            value={ACTION_TYPES.HOLD}
                            onChange={() =>
                              handleApprovalStatus(ACTION_TYPES.HOLD)
                            }
                          />{" "}
                          {<GetLanguageString props="notifications_hold" />}
                        </Label>
                      </Col>
                    </Row>
                  </FormGroup>

                  <Row>
                    <Label className="col-form-label">
                      <h4>
                        {
                          <GetLanguageString props="member_member_detail_course_comments" />
                        }
                      </h4>
                      <Input
                        type="text"
                        name="comments"
                        className={`no-drag`}
                        value={getStringFromJSX(
                          applyClassToCharacters(
                            state.notificationAction.comments,
                            "ur"
                          )
                        )}
                        onChange={handleInputChange}
                      />
                    </Label>
                  </Row>
                  {unitTypeName === "Markaz" ? (
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label className="col-form-label">
                            <GetLanguageString props="transactions_bank_deposit_slip_number" />
                          </Label>
                          <Input
                            type="text"
                            name="refrenceNo"
                            value={getStringFromJSX(
                              applyClassToCharacters(
                                state.notificationAction.refrenceNo,
                                "ur"
                              )
                            )}
                            onChange={handleInputChange}
                            invalid={!!errors.refrenceNo}
                          />
                          {errors.refrenceNo && (
                            <FormFeedback>
                              <h4>{errors.refrenceNo}</h4>
                            </FormFeedback>
                          )}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label className="col-form-label">
                            <GetLanguageString props="deposit_slip" />
                          </Label>
                          <Input
                            type="file"
                            name="extraFile"
                            onChange={(e) => {
                              const file = e.target.files[0];

                              setState((prev) => ({
                                ...prev,
                                extraFile: file,
                              }));

                              setErrors((prev) => ({
                                ...prev,
                                extraFile: "",
                              }));
                            }}
                            className={`form-control ${
                              errors.extraFile ? "is-invalid" : ""
                            }`}
                          />
                          {errors.extraFile && (
                            <div className="invalid-feedback d-block">
                              <h4>{errors.extraFile}</h4>
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  ) : unitTypeName === "Halqa" ? (
                    ""
                  ) : (
                    ""
                  )}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="white" onClick={toggle}>
                  {<GetLanguageString props="common_cancel" />}
                </Button>
                <Button
                  color="primary"
                  disabled={state.buttonDisable}
                  type="submit"
                >
                  {<GetLanguageString props="common_save_changes" />}
                </Button>
              </ModalFooter>
            </Form>
          </>
        )}
      </Modal>
    </Draggable>
  );
};

export default TransactionActionModal;
